import { useState, useEffect } from 'react';

/**
 * Debounces a value by the given delay (ms).
 * Returns the debounced value which only updates after `delay` ms of inactivity.
 */
export function useDebounce<T>(value: T, delay = 200): T {
    const [debounced, setDebounced] = useState<T>(value);

    useEffect(() => {
        const timer = window.setTimeout(() => setDebounced(value), delay);
        return () => window.clearTimeout(timer);
    }, [value, delay]);

    return debounced;
}

